import { FC } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import ErrorIcon from '@mui/icons-material/Error';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import './SCUIToast.scss';

interface IProps {
    type: 'success' | 'warning' | 'danger' | 'info' | 'error' | any;
    text: string;
    className?: string;
}

const iconMap: Record<string, React.JSX.Element> = {
    success: <CheckCircleIcon className="sc-toast__icon" />,
    info: <InfoIcon className="sc-toast__icon" />,
    danger: <ErrorIcon className="sc-toast__icon" />,
    warning: <WarningAmberIcon className="sc-toast__icon" />,
    error: <ErrorIcon className="sc-toast__icon" />,
};

export const SCUIToast: FC<IProps> = ({ type = 'success', text, className = '' }) => {
    return (
        <div className={`sc-toast sc-toast--${type} ${className}`}>
            {iconMap[type] || iconMap.success}
            <span className="sc-toast__text">{text}</span>
        </div>
    );
};
